import React from 'react';
import { InvisibleButton, MasonryUnsplashStyled } from './styles';

import { UNSPLASH_SERVICE } from '../../constants';
import { UnsplashLinks } from './UnsplashLinks';

import { GraphImage, IntegrationsService } from '../../types';

export type HandleImageCallback = (GraphImage) => void;

export const ImagesLayout = ({
  images,
  service,
}: {
  images: GraphImage[];
  service: IntegrationsService;
}) => {
  return (
    <MasonryUnsplashStyled
      breakpointCols={{
        default: 3,
        880: 2,
        596: 1,
      }}
      className="unsplash-masonry-grid"
      columnClassName="unsplah-masonry-column"
    >
      {images &&
        images.length > 0 &&
        images.map((image) => (
          <div className="gallery-item" key={image.id}>
            <InvisibleButton
              data-testid="integrations-gallery-item-button"
              type="button"
              onClick={() => {
                if (service.onFileSelected !== undefined)
                  service?.onFileSelected(image);
              }}
            >
              <img
                data-testid="ideas-images-layout-image"
                key={image.id}
                src={image.thumbnailUrl}
                alt={image.description || ''}
              />
            </InvisibleButton>
            {service?.id === UNSPLASH_SERVICE && (
              <UnsplashLinks imageLinked={image} />
            )}
          </div>
        ))}
    </MasonryUnsplashStyled>
  );
};
